import React from 'react';
import PropTypes from 'prop-types';
// import Media from 'react-media';
import * as common from '../../utilities/common';

const CardGroupBlock = (props) => {
  const { id, properties, cplaceholder, entities } = props;

  let isMosaic = false;
  let wrappedChilds = [];
  let childs = common.objectToArray(entities).filter(child => child.parentId === id);

  if (properties.preset.indexOf('mosaic') > -1 && childs.length > 1) {
    isMosaic = true;
    wrappedChilds = childs.slice(1);
    childs = childs.slice(0, 1);
  }

  // if (properties.preset === 'card-group-md' || properties.preset === 'card-group-lg') {
  //   return (
  //     <Media query="(max-width: 991px)">
  //       {matches => (matches ? (
  //         <div id={`carousel-${id}`} className="carousel card-carousel slide" data-ride="carousel">
  //           <div className="carousel-inner" role="listbox">
  //             {cplaceholder(null, 0, null, childs)}
  //           </div>
  //           <a className="carousel-control carousel-control-prev" href={`#carousel-${props.id}`} role="button" data-slide="prev">
  //             <span className="material-icons" aria-hidden="true">keyboard_arrow_left</span>
  //             <span className="sr-only">Previous</span>
  //           </a>
  //           <a className="carousel-control carousel-control-next" href={`#carousel-${props.id}`} role="button" data-slide="next">
  //             <span className="material-icons" aria-hidden="true">keyboard_arrow_right</span>
  //             <span className="sr-only">Next</span>
  //           </a>
  //         </div>
  //       ) : (
  //         <div className={`card-group ${properties.preset}`}>
  //           {cplaceholder(null, 0, null, childs)}
  //           {isMosaic && (
  //             <div className="card-wrap">
  //               {cplaceholder(null, 0, null, wrappedChilds)}
  //             </div>
  //           )}
  //         </div>
  //       ))}
  //     </Media>
  //   );
  // }

  return (
    <div className={`card-group ${properties.preset}`}>
      {cplaceholder(null, 0, null, childs)}
      {isMosaic && (
        <div className="card-wrap">
          {cplaceholder(null, 0, null, wrappedChilds)}
        </div>
      )}
    </div>
  );
};

CardGroupBlock.propTypes = {
  id: PropTypes.number,
  properties: PropTypes.object,
  cplaceholder: PropTypes.func,
  entities: PropTypes.object,
};

export default CardGroupBlock;
